<p *ngIf="!hasExistingDiscount">
  This membership does not currently have a one-time discount.
</p>

<p *ngIf="hasExistingDiscount">
  This membership currently has a {{ orgConfigService.formatCurrency(membership.one_off_discount_amount) }} one-time discount ({{ membership.one_off_discount_name }}).
</p>

<div class="form-group" *ngIf="hasExistingDiscount">
  <div class="form-check">
    <input class="form-check-input" type="radio"
           name="removeDiscountFalse" id="removeDiscountFalse"
           [(ngModel)]="removeDiscount" [value]="false">
    <label class="form-check-label" for="removeDiscountFalse">
      Edit Discount
    </label>
  </div>
  <div class="form-check">
    <input class="form-check-input" type="radio"
           name="removeDiscountTrue" id="removeDiscountTrue"
           [(ngModel)]="removeDiscount" [value]="true">
    <label class="form-check-label" for="removeDiscountTrue">
      Remove Discount
    </label>
  </div>
</div>

<ng-container *ngIf="!removeDiscount">

  <div class="form-group">
    <div class="row">
      <div class="col-lg-6 col-md-8">
        <label for="discountTypeSelect">Discount Value</label>
        <select id="discountTypeSelect" name="discountType"
                class="custom-select"
                [(ngModel)]="discountType">
          <option [ngValue]="MembershipDiscountType.currency">Flat Discount</option>
          <option [ngValue]="MembershipDiscountType.percentage">Percentage</option>
        </select>
      </div>
    </div>
  </div>

  <div class="form-group">
    <label for="discountAmountInput">Discount Amount</label>
    <div class="input-group">
      <div class="input-group-prepend" *ngIf="discountType === MembershipDiscountType.currency">
        <span class="input-group-text">{{ orgConfigService.getCurrencySymbol() }}</span>
      </div>
      <input class="form-control" type="number"
             min="0"
             [max]="discountType === MembershipDiscountType.currency ? '' : '100'"
             [step]="discountType === MembershipDiscountType.currency ? '0.01' : '1'"
             required
             id="discountAmountInput"
             name="discountAmount"
             [(ngModel)]="discountAmount">
      <div class="input-group-append" *ngIf="discountType === MembershipDiscountType.percentage">
        <span class="input-group-text">%</span>
      </div>
    </div>
  </div>

  <div class="form-group" *ngIf="discountType === MembershipDiscountType.percentage">
    <label for="appliesToAddOnsSelect">Does this discount apply to add-ons?</label>
    <div class="row">
      <div class="col-lg-6 col-md-8">
        <select class="custom-select" id="appliesToAddOnsSelect" name="discountAppliesToAddOns"
                [(ngModel)]="discountAppliesToAddOns">
          <option [ngValue]="false">No</option>
          <option [ngValue]="true">Yes</option>
        </select>
      </div>
    </div>
    <small class="form-text text-muted">
      If "Yes", this discount will be applied to add-ons, in addition to the base fee.
    </small>
  </div>

  <div class="form-group">
    <label for="discountNameInput">Discount Name</label>
    <input class="form-control" type="text" required
           id="discountNameInput" name="discountName" [(ngModel)]="discountName">
  </div>

</ng-container>

<div class="alert alert-danger" role="alert" *ngIf="errorMessage">
  {{ errorMessage }}
</div>
